import { distUI, envs, urlParams, windowObject } from '@ctct/infrastructure-layer';

import { showDebugToast } from './helpers';

export class TrackActionsServiceBase {
  private readonly DEBUG: boolean;

  constructor() {
    this.DEBUG = urlParams.getGa4Debug() === 'true';
  }

  protected ga4Track(action: string) {
    if (this.DEBUG) {
      showDebugToast(action);
    }

    if (envs.isSecure()) {
      return windowObject.gtag('event', 'click', { action });
    }

    return distUI.track({ action });
  }

  protected tealiumTrack(eventType: string, eventLabel: string, eventMetadata: string) {
    if (this.DEBUG) {
      showDebugToast(`${eventType} - ${eventLabel} - ${eventMetadata}`);
    }

    if (envs.isSecure()) {
      // we do not have access to the tealium in secure app
      return undefined;
    }

    return windowObject.trackTealium(eventType, eventLabel, eventMetadata);
  }
}
